/**
 * Geocoding (endereço → coordenadas) via proxy do bitbox-server (Google Geocoding API).
 */

import { getUser } from "../authentication";

/**
 * @param {string} query
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ lat: number, lon: number }|null>}
 */
export async function searchAddress(query, signal) {
  if (!query || !String(query).trim()) return null;

  try {
    const user = await getUser();
    if (!user || !user.service || !user.sessao || !user.sessao.token) {
      return null;
    }

    const params = new URLSearchParams({
      q: String(query).trim(),
      token: user.sessao.token,
    });
    const url = `${user.service}/api/geocode?${params.toString()}`;

    const res = await fetch(url, {
      signal,
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;

    const body = await res.json();
    if (!body || body.error !== 0 || !body.data) return null;

    const lat = parseFloat(body.data.lat);
    const lon = parseFloat(body.data.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;

    return { lat, lon };
  } catch (e) {
    if (e && e.name === "AbortError") throw e;
    return null;
  }
}
